module.exports = __webpack_public_path__ + "static/media/slideshow_3.fc735243.jpg";